import { render } from "./DayTypeFormPopup.vue?vue&type=template&id=54bef05e&scoped=true&ts=true"
import script from "./DayTypeFormPopup.vue?vue&type=script&lang=ts"
export * from "./DayTypeFormPopup.vue?vue&type=script&lang=ts"

import "./DayTypeFormPopup.vue?vue&type=style&index=0&id=54bef05e&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54bef05e"]])

export default __exports__